import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageImpl } from '../common/http/PageImpl';
import { GeofencePageCompositiveView } from '../+geocercas/geocercas.service';
import { RequestConfig } from '../shared/rest/rest.request';
import { RequestMethod, RequestOptions } from '@angular/http';
import { CustomHttp } from '../common/http/custom.http';
import { es_ES, NzI18nService } from 'ng-zorro-antd';
import { TicketView } from '../+tickets/ticket.service';
import Any = jasmine.Any;
import { HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';



@Injectable()
export class FoliosService {
    // private GET_PAGE = new RequestConfig('FOLIO01', 'application/json', true, RequestMethod.Get, '/folioElectronicoProxis/listado');
    private POST_PAGE = new RequestConfig('FOLIO01', 'application/json', true, RequestMethod.Post, '/folioElectronicoProxis/listado');
    // private GET_PAGE_FILTERED = new RequestConfig('FOLIO01', 'application/json', true, RequestMethod.Get, '/folioElectronicoProxis/listado?{idDocto}');
    private POST_PAGE_FILTERED = new RequestConfig('FOLIO01', 'application/json', true, RequestMethod.Post, '/folioElectronicoProxis/listado');
    private UPDATE_STATUS = new RequestConfig('FOLIO02', 'application/json', true, RequestMethod.Put, '/api/folio/{id_folio}/estatus?{estatus}');
    private DOWLOAD_FOLIO = new RequestConfig('FOLIO03', 'application/json', true, RequestMethod.Get, '/folioElectronicoProxis/{id_folio}/pdf');
    private SEND_SMS = new RequestConfig('FOLIO04', 'application/json', true, RequestMethod.Post, '/folioElectronicoProxis/{id_folio}/sms');
    private SEND_EMAIL = new RequestConfig('FOLIO05', 'application/json', true, RequestMethod.Post, '/folioElectronicoProxis/{id_folio}/email');
    private STREET_REQUEST = new RequestConfig('FOLIO06', 'application/json', true, RequestMethod.Get, '/calles');
    private SUBURB_REQUEST = new RequestConfig('FOLIO07', 'application/json', true, RequestMethod.Get, '/colonias');

    private GET_SALE = new RequestConfig('SLS007', 'application/json', true, RequestMethod.Get, '/ventas/{idVenta}');
    private UPDATE_SALE = new RequestConfig('SLS008', 'application/json', true, RequestMethod.Put, '/ventas/{idVenta}');
    private UPDATE_SALE_STATUS = new RequestConfig('SLS009', 'application/json', true, RequestMethod.Put, '/ventas/{idVenta}/estatus');
    private GET_REJECTION_REASONS = new RequestConfig('SLS010', 'application/json', true, RequestMethod.Get, '/ventas/motivos/rechazo');
    private REJECT_SALE = new RequestConfig('SLS011', 'application/json', true, RequestMethod.Put, '/ventas/{idVenta}/rechazo');
    private REJECT_SALE_ASIGNO = new RequestConfig('SLS011', 'application/json', true, RequestMethod.Put, '/ventas/asigno/{idVenta}/rechazo');
    private UPDATE_SALE_STATUS_ASIGNO = new RequestConfig('SLS012', 'application/json', true, RequestMethod.Put, '/ventas/{idVenta}/estatus/asigno');
    private UPDATE_SALE_STATUS_FOLIO = new RequestConfig('SLS012', 'application/json', true, RequestMethod.Put, '/ventas/{idVenta}/estatus/folioElectronico');
    private GET_SALE_IMAGES = new RequestConfig('SLS013', 'application/json', true, RequestMethod.Post, '/ventas/images');
    private GET_CALLES = new RequestConfig('SLS014', 'application/json', true, RequestMethod.Get, '/calle');
    private GET_COLONIAS = new RequestConfig('SLS015', 'application/json', true, RequestMethod.Get, '/colonia');
    private UPDATE_SALE_ACCEPT = new RequestConfig('SLS018', 'application/json', true, RequestMethod.Put, '/ventas/estatus/all');
    private UPDATE_SALE_REJECT = new RequestConfig('SLS018', 'application/json', true, RequestMethod.Put, '/ventas/estatus/rechazo/all');

    constructor(private http: CustomHttp,
                private i18n: NzI18nService) {
        this.i18n.setLocale(es_ES);
    }

    getPage(options: any): Observable<FoliosPageView>{
        return this.http.sendRequestApiMega(this.POST_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getPageFiltered(options: any, idDocto: any): Observable<FoliosPageView>{
        if (idDocto == 0){
            let provicional = {
                ... this.POST_PAGE
            }
            let url: string = provicional.uri;
            url = url + "?userName=" + options.userName + "&idUserApp=" + options.idUserApp;
            provicional.uri = url;

            return this.http.sendRequestApiMega(provicional, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
        } else {
            idDocto = 'id_docto=' + idDocto;
           
            let provicional = {
                ... this.POST_PAGE_FILTERED
            }
            let url: string = provicional.uri;
            url = url + "?userName=" + options.userName + "&idUserApp=" + options.idUserApp;
            provicional.uri = url;
            
            return this.http.sendRequestApiMega(provicional, options, idDocto)
                .map(res => res.json())
                .catch(error => this.http.handleError(error));
        }
    }

    updateStatus(estatus: any, idFolio: any): Observable<any>{
        estatus = 'estatus=' + estatus;
        return this.http.sendRequestApiMega(this.UPDATE_STATUS, {}, idFolio, estatus)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    dowloadPdfFolio(idFolio: number): Observable<PDFView> {
        return this.http.sendRequestApiMega(this.DOWLOAD_FOLIO, {}, idFolio)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    sendSMS(idFolio: any, telefono: string): Observable<Any> {
        let body = {
            telefono: telefono
        };
        return this.http.sendRequestApiMega(this.SEND_SMS, body, idFolio)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    sendEmail(idFolio: any, email: string): Observable<Any> {
        let body = {
            email: email
        };
        return this.http.sendRequestApiMega(this.SEND_EMAIL, body, idFolio)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    streetFromMega(streetName: string, extra1?: string): Observable<StreetResponse> {
        const streetRequest: StreetRequest = {
            parcial: streetName,
            sucursal: +extra1,
            pageNumber: 1,
            pageSize: 1000
        };
        return this.http.sendRequestApiMega(this.STREET_REQUEST, streetRequest)
            .map((response) => (response.json() as StreetResponse[]).shift());
    }

    streetFromMegaById(idStreet: string, extra1?: string): Observable<any> {
        const streetRequest: StreetRequest = {
            idCalle: idStreet,
            sucursal: +extra1,
            pageNumber: 1,
            pageSize: 1000,
        };
        return this.http.sendRequestApiMega(this.GET_CALLES, streetRequest)
        .map((response) => (response.json()));
    }

    suburbFromMega(suburbName?: string, extra1?: string): Observable<SuburbResponse> {
        const suburbRequest: SuburbRequest = {
            parcial: suburbName,
            sucursal: +extra1,
            pageNumber: 1,
            pageSize: 1000
        };
        return this.http.sendRequestApiMega(this.SUBURB_REQUEST, suburbRequest)
            .map((response) => (response.json() as SuburbResponse[]).shift())
    }

    suburbFromMegaById(idSuburb?: string, extra1?: string): Observable<any> {
        const suburbRequest: SuburbRequest = {
            idColonia: idSuburb,
            sucursal: +extra1,
            pageNumber: 1,
            pageSize: 1000
        };
        return this.http.sendRequestApiMega(this.GET_COLONIAS, suburbRequest)
            .map((response) => (response.json()));
    }


    getSale(idVenta: string, request:any): Observable<SaleRequest> {
        return this.http.sendRequestApiMega(this.GET_SALE, request, idVenta)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    updateSale(idVenta: string, sale: SaleRequest): Observable<any> {
        return this.http.sendRequestApiMega(this.UPDATE_SALE, sale, idVenta)
            .catch(error => this.http.handleError(error));
    }

    updateSaletatus(idVenta: string, salesStatus: string): Observable<any> {
        return this.http.sendRequestApiMega(this.UPDATE_SALE_STATUS, salesStatus, idVenta)
            .catch(error => this.http.handleError(error));
    }

    getRejectionReasons(): Observable<Array<RejectionReasons>> {
        return this.http.sendRequestApiMega(this.GET_REJECTION_REASONS)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    rejectSale(idsVenta, body: RejectSale): Observable<any> {
        return this.http.sendRequestApiMega(this.REJECT_SALE,body,idsVenta)
            .catch(error => this.http.handleError(error));
    }

    cancelSale(idsVentas: any, body: CancelSale): Observable<any> {
        return this.http.sendRequestApiMega(this.REJECT_SALE,body,idsVentas)
            .catch(error => this.http.handleError(error));
    }

    rejectSaleAsigno(idVenta: any, body: RejectSaleAsigno): Observable<any> {
        return this.http.sendRequestApiMega(this.REJECT_SALE_ASIGNO, body, idVenta)
            .catch(error => this.http.handleError(error));
    }

    cancelSaleAsigno(idVenta: any, body: CancelSaleAsigno): Observable<any> {
        return this.http.sendRequestApiMega(this.REJECT_SALE_ASIGNO, body, idVenta)
            .catch(error => this.http.handleError(error));
    }


    updateSaletatusAsigno(idVenta: string, salesStatus: ChangeStatusSale): Observable<any> {
        return this.http.sendRequestApiMega(this.UPDATE_SALE_STATUS_ASIGNO, salesStatus, idVenta)
            .catch(error => this.http.handleError(error));
    }

    updateSaletatusFolioElectronico(idVenta: string, salesStatus: ChangeStatusSale): Observable<any> {
        return this.http.sendRequestApiMega(this.UPDATE_SALE_STATUS_FOLIO, salesStatus, idVenta)
            .catch(error => this.http.handleError(error));
    }

    getSaleImages(saleImagesRequest: SalesImages): Observable<SalesImagesResponse[]> {
        return this.http.sendRequestApiMega(this.GET_SALE_IMAGES, saleImagesRequest)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    acceptSale(idsVenta, statusSale: ChangeStatusSale): Observable<any> {
        return this.http.sendRequestApiMega(this.UPDATE_SALE_STATUS, statusSale, idsVenta)
            .catch(error => this.http.handleError(error));
    }

    acceptUpdateSale(idsVentas: RequestAcceptRejectSale): Observable<updateStatusResponse[]> {
        return this.http.sendRequestToUrl(environment.API_SFYC,this.UPDATE_SALE_ACCEPT, idsVentas)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
      }
    
      rejectUpdateSale(idsVentas: RequestAcceptRejectSale): Observable<updateStatusResponse[]> {
        return this.http.sendRequestToUrl(environment.API_SFYC, this.UPDATE_SALE_REJECT, idsVentas)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
      }

}


export enum DocumentType {
    RECUPERACION_EQUIPOS = 1,
    PAGO_DE_SERVICIOS = 2,
    CONTRATO_MEGACABLE_TRIPLE = 4,
}
export class FoliosPageView {
    // public content: Array<FoliosView> = [];
    public first: boolean;
    public last: boolean;
    // public number: number;
    // public numberOfElements: number;
    // public size: number;
    // public totalElements: number;
    // public totalPages: number;


    public cantidad: number;
    public pagina: number;
    public total: number;
    public parametros: ParameterView;
    // public folios: FoliosView = new FoliosView();
    public folios: Array<FoliosView> = [];
    // public folios: Array<any> = [];



}
export class FoliosView {
    id_folio: string;
    id_folio_externo: number;
    id_venta?: any;
    fecha_creacion: string;
    id_docto: number;
    json_generado: any;
    sucursal: number;
    suscriptor: string;
    nombre_suscriptor: string;
    nombre_vendedor: string;
    estatus: string;
    username: string;
    tipoContrato?: string;
    fechaLegible?: any;
    estado_venta: string;
    supervisor?: any;
    costo?:any;
    efectivo?: any;
    whatsapp?:any;
    idGrupo?: number;
    id_ticket?: number;
    // Es el mismo que id_folio pero llega desde clientes
    id?: string; 
}

export class ParameterView {
    nombre_suscriptor: string;
    nombre_vendedor: string;
    estatus: string;
    sucursal: number;
    suscriptor:number;
    folioExterno: number;
    desdeFecha: any;
    hastaFecha: any;
}
export class ficticia{
    folio: FoliosView = new FoliosView();
}


export class FolioAdvanceSearch {
    folioExterno: number;
    sucursal: number;
    suscriptor: number;
    supervisor: any;
    pagina: number;
    cantidad: number;
    desdeFecha: any;
    hastaFecha: any;
    nombreSuscriptor: string;
    nombreVendedor: string;
    estadoVenta: string;
    cuadrilla: string;
    order? : String;
    orderType? : String;
    estatus:string;
    id_docto:string;
    solicitudVenta:any;
}
export class PDFView {
    file: any;
    fileName: string;
    enviar_email: string;

}

export class ListaErrorsForms {
    controlName: string;
    errorName: string;
    nombreReal: string;

    constructor(controlName?: string, errorName?: string, nombreReal?: string) {
        if (controlName && errorName) {
            this.controlName = controlName;
            this.errorName = errorName;
            this.nombreReal = nombreReal;
        }
    }
}

export class SaleRequest {
    id?: string;
    nombre_cliente: string;
    apellido_pat: string;
    apellido_mat: string;
    id_colonia: string;
    id_calle: string;
    numero_ext: any = "";
    numero_int: any = "";
    id_entreCalle1: string;
    id_entreCalle2: string;
    bis: string = "";
    orientacion: string = "";
    observaciones: string = "";
    observaciones_rechazo: string = "";
    estatus_venta: string = "";
    motivo_rechazo: string;
    message?: string;
    code?: any;
    detalle_paquete?: string;
    suscriptor?: any;
    referenciaBancaria?: any;
    whatsapp?:any;
}

export class SaleStatus {
    nuevoId = 'NVO';
    nuevo = 'Nuevo';
    aceptadoSupervisorId = 'ACS';
    aceptadoSupervisor = 'Aceptado Supervisor';
    rechazadoSupervisorId = 'RPS';
    rechazadoSupervisor = 'Rechazado Supervisor';
    aceptadoIngresosId = 'ACI';
    aceptadoIngresos = 'Aceptado Ingresos';
    rechazadoIngresosId = 'RPI';
    rechazadoIngresos = 'Rechazado Ingresos';
    canceladoId = 'CAN';
    cancelado = 'Cancelado'
    //Agregue
    aceptadoSupRecuperadorClientsId = 'ACC';
    aceptadoSupRecuperadorClients = 'Aceptado Supervisor Recuperadores Clientes';
}

export class SuburbResponse {
    totalResults: number;
    pagesCount: number;
    pageNumber: number;
    pageSize: number;
    colonias: SuburbFromMega[];
}

export class SuburbFromMega {
    id: string;
    nombre: string;
    sector: string;
    nse: string;
    fechaActivacion: Date;
    tipoComunicacion: string;
    codificada: {
        valor: boolean,
        fechaInicio: Date
    };
    subterranea: boolean;
    digital: boolean;
    competencia: boolean;
    docsis30: boolean;
    hfc: boolean;
    gpon: boolean;
    restringidos: string;
    metroCarrier: boolean;
}

export class SuburbRequest {
    sucursal: number;
    parcial?: string;
    pageNumber: number;
    pageSize: number;
    idSuburb?: string;
    idCalle?: string;
    idColonia?: string;
}


export class StreetRequest {
    sucursal: number;
    parcial?: string;
    pageNumber: number;
    pageSize: number;
    idStreet?: string;
    idCalle?: string;
    idColonia?: string;
}

export class GetStreetColony{
    idCalle?: string;
    idColonia?: string;
}

export class StreetResponse {
    totalResults: number;
    pagesCount: number;
    pageNumber: number;
    pageSize: number;
    calles: StreetFromMega[];
}

export class GetStreetColonyResponse {
   id?: [];
   colonia?:[];
   calle?:[];
}

export class StreetFromMega {
    id: string;
    nombre: string;
}


export class RejectSale {
    estatus_venta: string;
    motivoRechazo: string;
    observaciones: string;
}

export class CancelSale {
    estatus_venta: string;
    observaciones: string;
    motivoRechazo: string = '';
}

export class RejectSaleAsigno {
    idMotivoRechazo: number;
    estatus_venta: string;
}

export class CancelSaleAsigno {
    estatus_venta: string;
    idMotivoRechazo: number = 0;
}

export class RejectionReasons {
    id_reason: number;
    reason: string;
}

export class SalesImages {
    solicitudVenta: any;
    code: number[];
}

export enum Code {
    INE_FRONTAL = 1,
    RECIBO_LUZ = 2,
    INE_TRASERA = 3,
    EVIDENCIA_PAGO = 10,
    FIRMA = 11,
    FACHADA = 4,
    COMPETENCIA = 5,
    ARRENDAMIENTO = 6,
    EXTRA_UNO = 7,
    EXTRA_DOS = 8,
    EXTRA_TRES = 9
}

export class SalesImagesResponse {
    code: number;
    contentType: any;
    fileBase64Content?: null;
    fileName: string;
    fileSystemPath?: string[];   
    idTicket:number;
    name?:string;
    fileB64Content?: any;
}


export class RejectionReasonAsigno {
    idMotivoRechazo: number;
    estatus_venta: string;
}

export class ChangeStatusSale{
    estatusVenta: string;
}

export class RequestAcceptRejectSale {
    data: Datum[];
}

export class Datum {
    idVenta: string;
    solicitudVenta: number;
    estatusVenta: string;
    cajero?: number;
    sucursal?: number;
    observaciones?: number;
    idMotivoRechazo?: number;
    motivoRechazo?: any;
    idGrupo: number;
}

export class updateStatusResponse {
    idVenta: string;
    mensaje: string;
    observaciones: string;
}